import forOwn from 'mout/object/forOwn'
import findCollection from './findCollection'
import { db } from '../../../config/firebaseconfig'
import queryString from 'query-string'
import getRequest from '../../getRequest';
import saveRecordChanges from './saveRecordChanges';

export default function saveChanges(record, data) {
  const { firstName, lastName, username, email, sfid } = data
  if (!record.role) {
    return saveRecordChanges(record, data)
  }
  const { schoolDistrict } = record

  function checkForChanges(record, data, key) {
    if (record[key] === data[key]) {
      return false
    } else return true
  }

  // sets up update object
  let update = {}
  forOwn(data, function addToUpdate(val, key) {
    if (checkForChanges(record, data, key)) {
      update[key] = val
    }
  })

  // update fullName as well!
  if (update.firstName || update.lastName) {
    const firstN = update.firstName ? update.firstName : record.firstName
    const lastN = update.lastName ? update.lastName : record.lastName
    const fullName = `${firstN} ${lastN}`
    update.fullName = fullName
  }

  const collection = findCollection(record)
  if (!collection) {
    return Promise.reject('Invalid record.')
  }

  // sets up query if need to check for email/username duplication
  let query = {}, url = ''
  let needToCheckDuplication = false
  query.schoolDistrict = schoolDistrict
  if (update.email) {
    query.email = update.email
    needToCheckDuplication = true
  }
  if (update.username) {
    query.username = update.username
    needToCheckDuplication = true
  }
  if (needToCheckDuplication) {
    const CHECK_DUP_BASE_URL = 'https://us-central1-bellwork-cg1.cloudfunctions.net/checkDuplication'
    url = `${CHECK_DUP_BASE_URL}?${queryString.stringify(query)}` 
    return getRequest(url)
      .then((res) => {
        const resp = JSON.parse(res)
        console.log('resp', resp)
        if (resp.error) {
          throw resp.error
        } else {
          return db.collection(collection).doc(record.id).update(update)
        }
      })
      .catch((err) => {
        console.log(err)
        return Promise.reject(err)
      })
  } else {
    return db.collection(collection).doc(record.id).update(update)
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/saveChanges.js